import type {PublicMethodUtils} from '@wix/document-services-types'
import type {MobileAlgoPublicAPI} from '@wix/document-services-public-types'
import _ from 'lodash'
import {responsify} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<MobileAlgoPublicAPI> {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils
    return {
        methods: {
            mobileAlgo: {
                groupings: {
                    removeLastGroupingHashFromAllPages: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromAllPages'
                    ),
                    removeLastGroupingHashFromPage: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromPage'
                    ),
                    removeLastGroupingHashFromSection: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromSection'
                    ),
                    getLastGroupingHash: getter('mobileAlgo.groupings.getLastGroupingHash')
                },
                run: publicMethodUtils.defineDataManipulationAction(_.noop, {
                    asyncPreDataManipulation: responsify.run,
                    isAsyncOperation: true,
                    noBatching: true
                }),
                runForPage: publicMethodUtils.defineDataManipulationAction(_.noop, {
                    asyncPreDataManipulation: responsify.runForPage,
                    isAsyncOperation: true,
                    noBatching: true
                }),
                locking: {
                    unlockSectionsForAllPages: dataManipulation('mobileAlgo.locking.unlockSectionsForAllPages'),
                    unlockSectionsForPage: dataManipulation('mobileAlgo.locking.unlockSectionsForPage'),
                    softLock: publicMethodUtils.defineDataManipulationAction(_.noop, {
                        asyncPreDataManipulation: responsify.locking.softLock,
                        isAsyncOperation: true
                    }),
                    softLockPage: publicMethodUtils.defineDataManipulationAction(_.noop, {
                        asyncPreDataManipulation: responsify.locking.softLockPage,
                        isAsyncOperation: true
                    })
                },
                utils: {
                    getFontSize: getter('mobileAlgo.utils.getFontSize')
                }
            }
        }
    }
}
